export const ADMISSION_STATUS_SELECT_TEST_ID = 'admission-status-select';

export const ADMISSION_STATUS_SELECT_SIZE_S = 'S';
export const ADMISSION_STATUS_SELECT_SIZE_L = 'L';
